import { Coordinates } from '../Mapbox'
import { useTranslation } from '../Translation'
import { PrefectureIndex } from '../Util'
import { useJapaneseArtisanArticles } from './useJapaneseArtisanArticles'
import { useEnglishArtisanArticles } from './useEnglishArtisanArticles'

export type Artisan = ArtisanPartFromMicrocms & ArtisanPartFromMapbox

type Prefecture = keyof typeof PrefectureIndex
export type ArtisanPartFromMicrocms = {
  id: string
  workshop: string
  workshopEn: string
  prefectureIndex: number
  prefecture: Prefecture
  city: string
  blogIds: string[]
}

export type ArtisanPartFromMapbox = {
  coordinates: Coordinates
  prefectureEn: string
  cityEn: string
}

export type RawArtisanPartFromMicrocms = {
  id: string
  workshop: string
  workshopEn: string
  location: string
  blogIds: { id: string }[]
}

export const convertToArtisanPartFromMicrocms = (
  rawData: RawArtisanPartFromMicrocms,
): ArtisanPartFromMicrocms => {
  // 既に半角 or 全角スペースが入っていても対応できるように設定
  const regex = /(.{2,3}[都道府県])[\u{20}\u{3000}]?/u
  const prefecture = rawData.location.match(regex)?.[1] as
    | Prefecture
    | undefined
  const city = rawData.location.replace(regex, '')
  const prefectureIndex =
    PrefectureIndex[prefecture as keyof typeof PrefectureIndex]

  if (prefecture === undefined || !prefectureIndex) {
    throw new Error(`都道府県名が不正です: ${prefecture}`)
  }
  return {
    ...rawData,
    prefectureIndex,
    prefecture,
    city,
    blogIds: rawData.blogIds.map(blogId => blogId.id),
  }
}

export const useArtisanArticles = () => {
  const { locale } = useTranslation()
  const japanesseArticles = useJapaneseArtisanArticles()
  const englishArticles = useEnglishArtisanArticles()

  return locale === 'en' ? englishArticles : japanesseArticles
}
